import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.string.link";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import PropTypes from 'prop-types';
import React from 'react';
import { Linking, StyleSheet, View, ViewPropTypes } from 'react-native'; // @ts-ignore

import ParsedText from 'react-native-parsed-text';
import Communications from 'react-native-communications';
var WWW_URL_PATTERN = /^www\./i;
var textStyle = {
  fontSize: 16,
  lineHeight: 20,
  marginTop: 5,
  marginBottom: 5,
  marginLeft: 10,
  marginRight: 10
};
var styles = {
  left: StyleSheet.create({
    container: {},
    text: _objectSpread({
      color: 'black'
    }, textStyle),
    link: {
      color: 'black',
      textDecorationLine: 'underline'
    }
  }),
  right: StyleSheet.create({
    container: {},
    text: _objectSpread({
      color: 'white'
    }, textStyle),
    link: {
      color: 'white',
      textDecorationLine: 'underline'
    }
  })
};

var MessageText =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MessageText, _React$Component);

  function MessageText() {
    var _this;

    _classCallCheck(this, MessageText);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MessageText).apply(this, arguments));

    _this.onUrlPress = function (url) {
      // When someone sends a message that includes a website address beginning with "www." (omitting the scheme),
      // react-native-parsed-text recognizes it as a valid url, but Linking fails to open due to the missing scheme.
      if (WWW_URL_PATTERN.test(url)) {
        _this.onUrlPress("http://".concat(url));
      } else {
        Linking.canOpenURL(url).then(function (supported) {
          if (!supported) {
            console.error('No handler for URL:', url);
          } else {
            Linking.openURL(url);
          }
        });
      }
    };

    _this.onPhonePress = function (phone) {
      var options = ['Call', 'Text', 'Cancel'];
      var cancelButtonIndex = options.length - 1;

      _this.context.actionSheet().showActionSheetWithOptions({
        options: options,
        cancelButtonIndex: cancelButtonIndex
      }, function (buttonIndex) {
        switch (buttonIndex) {
          case 0:
            Communications.phonecall(phone, true);
            break;

          case 1:
            Communications.text(phone);
            break;

          default:
            break;
        }
      });
    };

    _this.onEmailPress = function (email) {
      return Communications.email([email], null, null, null, null);
    };

    return _this;
  }

  _createClass(MessageText, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !!this.props.currentMessage && !!nextProps.currentMessage && this.props.currentMessage.text !== nextProps.currentMessage.text;
    }
  }, {
    key: "render",
    value: function render() {
      var linkStyle = [styles[this.props.position].link, this.props.linkStyle && this.props.linkStyle[this.props.position]];
      return React.createElement(View, {
        style: [styles[this.props.position].container, this.props.containerStyle && this.props.containerStyle[this.props.position]]
      }, React.createElement(ParsedText, {
        style: [styles[this.props.position].text, this.props.textStyle && this.props.textStyle[this.props.position], this.props.customTextStyle],
        parse: [].concat(_toConsumableArray(this.props.parsePatterns(linkStyle)), [{
          type: 'url',
          style: linkStyle,
          onPress: this.onUrlPress
        }, {
          type: 'phone',
          style: linkStyle,
          onPress: this.onPhonePress
        }, {
          type: 'email',
          style: linkStyle,
          onPress: this.onEmailPress
        }]),
        childrenProps: _objectSpread({}, this.props.textProps)
      }, this.props.currentMessage.text));
    }
  }]);

  return MessageText;
}(React.Component);

export { MessageText as default };
MessageText.contextTypes = {
  actionSheet: PropTypes.func
};
MessageText.defaultProps = {
  position: 'left',
  currentMessage: {
    text: ''
  },
  containerStyle: {},
  textStyle: {},
  linkStyle: {},
  customTextStyle: {},
  textProps: {},
  parsePatterns: function parsePatterns() {
    return [];
  }
};
MessageText.propTypes = {
  position: PropTypes.oneOf(['left', 'right']),
  currentMessage: PropTypes.object,
  containerStyle: PropTypes.shape({
    left: ViewPropTypes.style,
    right: ViewPropTypes.style
  }),
  textStyle: PropTypes.shape({
    left: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    right: PropTypes.oneOfType([PropTypes.object, PropTypes.number])
  }),
  linkStyle: PropTypes.shape({
    left: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    right: PropTypes.oneOfType([PropTypes.object, PropTypes.number])
  }),
  parsePatterns: PropTypes.func,
  textProps: PropTypes.object,
  customTextStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.number])
};